import React from 'react';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../sessionStorage';
import Testimonials from './Testimonials';

export default function TestimonialPanel() {

    const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    const isTestimonialPanelEnable = accountObj && accountObj.account && accountObj.account.isTestimonialPanelEnable;

    return (
        isTestimonialPanelEnable && <div className='mt-3'><Testimonials /></div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Common/Testimonials/TestimonialPanel.js